import * as React from 'react';
import {
  Button,
  Dialog, DialogActions, DialogContent, DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import getBinNames from '../../lib/SWRfetchers/getBinNames';

interface ReassignRepairDialogProps {
  onClose: () => void;
  showModal: boolean;
  setBin: React.Dispatch<React.SetStateAction<string>>;
  handleReassign: () => void;
  repairCount: number;
}

const ReassignRepairDialog: React.FC<ReassignRepairDialogProps> = ({
  showModal, onClose, handleReassign, setBin, repairCount,
}) => {
  const { binNames } = getBinNames();

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={showModal} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="overline">
          {'SELECT REASSIGNMENT'}
        </Typography>
        <Typography variant="h5" id="dialog-header">{`Reassign ${repairCount} scanned repairs.`}</Typography>
        <Typography variant="body2" id="dialog-subHeader">{'Choose a new location and place the repair items in the correct bin.'}</Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sm={12}>
            {
                binNames && (
                <Autocomplete
                  onChange={(event, selectedOption) => {
                    if (selectedOption) {
                      setBin(selectedOption?.value);
                    }
                  }}
                  autoHighlight
                  options={binNames.filter((option) => !option.value.toLowerCase().includes('courier -'))} // filter out all the courier bins.
                  getOptionLabel={(option) => option.value}
                  getOptionSelected={(option, value) => option.value === value.value}
                  renderInput={(params) => (
                    <TextField
                    // eslint-disable-next-line react/jsx-props-no-spreading
                      {...params}
                      label="Reassign to Location"
                      placeholder="Start Typing to search"
                      variant="outlined"
                    />
                  )}
                />
                )
            }
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="text" onClick={handleClose}>{'CANCEL'}</Button>
        <Button color="primary" variant="contained" onClick={() => handleReassign()}>{'CONFIRM'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReassignRepairDialog;
